import H2 from "@/atoms/text/H2";
import Para from "@/atoms/text/Para";
import Image from "@/atoms/Image";
import { useState, useEffect } from "react";
import { isMobileScreen } from "@/utils/functions";

export default function Locations({
  title,
  para,
  color,
  className,
  image,
  locationData,
}) {
  const [isMobile, setIsMobile] = useState(null);
  useEffect(() => {
    setIsMobile(isMobileScreen);
  }, []);

  const finalLocationData = isMobile ? locationData.slice(0, 8) : locationData;

  const locationsData = finalLocationData.map((location, idx) => {
    const locationStyle =
      "text text--lg" +
      (!isMobile && idx <= finalLocationData.length - 6 ? " mb-5" : "") +
      (isMobile && idx <= finalLocationData.length - 3 ? " mb-5" : "");

    return (
      <li key={idx} className={locationStyle}>
        {location}
      </li>
    );
  });

  return (
    <>
      <section className={`locations pv-15-d pv-8 ${className} ps-r`}>
        <div className="container ta-center">
          {title && (
            <H2
              color={color}
              className="mb-5-d mb-3 bold"
              dangerouslySetInnerHTML={{
                __html: `${title}<span class="dot">.</span>`,
              }}
            ></H2>
          )}
          {para && (
            <Para
              desktopSize="lg"
              mobileSize="lg"
              color={color}
              className="mb-8-d mb-6"
            >
              {para}
            </Para>
          )}
          <Image
            fileName={image.fileName}
            fileFormat="png"
            desktopWidth={image.desktopWidth}
            mobileWidth={image.mobileWidth}
            alt={image.altText}
          />
          <ul className="locationsList m-center fx fx--w tc-white">
            {locationsData}
            <style global jsx>{`
              .locationsList li {
                width: 20%;
              }
              .locationsList {
                max-width: 1040px;
              }
              @media (max-width: 1200px) {
                .locationsList li {
                  width: 50%;
                }
              }
              .locations img {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
              }
            `}</style>
          </ul>
        </div>
      </section>
    </>
  );
}

Locations.defaultProps = {
  className: "bc-grad-blue",
  color: "white",
};
